/**
 电站运行看板-设备数据
 */

import React, { Component } from "react";
import { Progress, Tooltip, Popover, Modal, Button, message, Select, TreeSelect } from "antd";
import {
  getCityList,
  queryDeviceAreaNumQry,
  userManagerRegionList,
  queryNewDeviceNum,
  geServiceCompanyListrOptions,
  queryNewDeviceStatus,
} from "@/fetch/fetchApi";
import fetchHandler from "@/fetch/fetchHandler";
import FormCore from "@/components/display/form/formCore";
import moment from "moment";
import PropTypes from "prop-types";
import PeoplePieChart from "@/pages/displayBoard/deviceBordStatusSub";
import icon1 from "@/assets/img/displayBoard/电站.png";
import icon2 from "@/assets/img/displayBoard/终端总数.png";
import icon3 from "@/assets/img/displayBoard/交流.png";
import icon4 from "@/assets/img/displayBoard/额定功率.png";
import icon5 from "@/assets/img/displayBoard/直流.png";
import DeviceInfoSub from "@/pages/displayBoard/deviceInfoSub";
import PeopleZhuPage from "@/pages/displayBoard/peopleZhuPage";
import StationModal from "../configurationManagement/stub/stationModal";
import ExportJsonExcel from "js-export-excel";
// css
import "@/assets/stylus/displayBoard.styl";
// icon
import { RightOutlined, QuestionCircleFilled, QuestionCircleOutlined } from "@ant-design/icons";
// 国际化切换语言
import { connect } from "react-redux";
import { injectIntl } from "react-intl";

@connect((state) => state)
class DeviceWatchPlat extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.internationalization = this.props.intl.messages.stubList;
    this.yunwei = this.props.intl.messages.commonBase;

    this.state = {
      pieData: [],
      areaDTOList: [],
      barData: [],
      peopleData: [],
      userList: [
        {
          text: "全部",
          value: "",
        },
      ],
      companyList: [
        {
          text: "全部",
          value: "",
        },
      ],
      ticketTypeList: [
        {
          text: "全部",
          value: "",
        },
        {
          text: "非直营",
          value: "0",
        },
        {
          text: "直营",
          value: "1",
        },
      ],
      levelTypeList: [
        {
          text: "全部",
          value: "",
        },
        {
          text: "交流电",
          value: "0",
        },
        {
          text: "直流电",
          value: "1",
        },
        {
          text: "交直流",
          value: "2",
        },
      ],
      cityTypeList: [
        {
          text: "全部",
          value: "",
        },
        {
          text: "A类",
          value: "1",
        },
        {
          text: "B类",
          value: "2",
        },
        {
          text: "C类",
          value: "3",
        },
      ],
      areaList: [
        {
          text: "全部",
          value: "",
        },
      ],
      param: {
        cityIds: "",
        provinceIds: "000000", // 默认 000000全国
        date: "",
        operationProperty: "3",
        areaIds: "",
      },
      equipmentQry: {
        station: 0, // 桩群数量
        powerBox: 0, // 配电柜数量
        stub: 0, // 桩数量
      },
      successRate: "0",
      stubIntactRate: "0",
    };
  }

  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  // 页面加载前方法
  componentWillMount() {
    this.setState({
      formConfig: this.initForm(),
    });
    this.getCityList();
    this.getEquipmentQry();
    this.getAreaList();
    this.getCompany();
    this.getAuthUser();
  }

  // 页面加载完成方法
  componentDidMount() {}

  /**
   * 获取充电成功率数字
   */
  getSuccessRate = (value) => {
    this.setState({
      successRate: value,
    });
  };

  /**
   * 获取设备状态
   */
  getStubIntactRate = (value) => {
    console.info("干嘛的");
    this.setState({
      stubIntactRate: value,
    });
  };

  /**
   * 获取设备其他数据
   */
  getAreaList() {
    let that = this;
    if (
      this.state.param.infoType != null &&
      (this.state.param.cityIds == null || this.state.param.cityIds == "") &&
      (this.state.param.provinceIds == null || this.state.param.provinceIds == "")
    ) {
      this.setState(
        {
          areaList: [],
        },
        () => {
          this.setState({
            formConfig: this.initForm(),
          });
        },
      );
      return;
    }
    fetchHandler(userManagerRegionList, {
      userId: sessionStorage.getItem("userId"),
    }).then((res) => {
      if (res.data) {
        res.data.forEach(function (item) {
          item.text = item.regName;
          item.value = item.areaId;
        });
        res.data.unshift({
          text: "全部",
          value: "",
        });
        this.setState(
          {
            areaList: res.data,
          },
          () => {
            this.setState({
              formConfig: this.initForm(),
            });
          },
        );
      }
    });
  }

  //type:1：电站，2：设备，3：直流设备，4：交流设备，5：额定功率
  getAreaNumList(type) {
    if (
      this.state.param.infoType != null &&
      (this.state.param.cityIds == null || this.state.param.cityIds == "") &&
      (this.state.param.provinceIds == null || this.state.param.provinceIds == "")
    ) {
      return;
    }
    let that = this;
    fetchHandler(queryDeviceAreaNumQry, {
      type: type,
      userId: this.state.param.userId,
      companyId: this.state.param.companyId,
      operationMode: this.state.param.operationMode,
      stubType: this.state.param.stubType,
      cityIds: this.state.param.cityIds,
      areaIds: this.state.param.areaIds,
      provinceIds: this.state.param.provinceIds,
    }).then((res) => {
      if (res.data) {
        var list = [];
        var fAreaId = null;
        var index = 0;
        if (res.data.areaNums && res.data.areaNums.length > 0) {
          res.data.areaNums.forEach(function (item) {
            var one = {};
            one.id = item.id;
            one.text = item.name;
            one.num = item.stationNum;
            if (index == 0) {
              fAreaId = item.id;
              one.choosed = 2;
            } else {
              one.choosed = 1;
            }
            index++;
            list.push(one);
          });
        }
        this.setState(
          {
            areaDTOList: list,
            fAreaId: fAreaId,
            modalType: type,
            modalTitle:
              type == 1
                ? "电站"
                : type == 2
                ? "设备"
                : type == 3
                ? "直流设备"
                : type == 4
                ? "交流设备"
                : "额定功率",
            modalStationNum: res.data.stationNum,
            modalStationTitle: list.length > 0 ? list[0].text : "",
          },
          () => {
            this.setState({
              areaDTOList: list,
              fAreaId: fAreaId,
              modalTitle:
                type == 1
                  ? "电站"
                  : type == 2
                  ? "设备"
                  : type == 3
                  ? "直流设备"
                  : type == 4
                  ? "交流设备"
                  : "额定功率",
              modalType: type,
              modalStationNum: res.data.stationNum,
              modalStationTitle: list.length > 0 ? list[0].text : "",
            });
            this.modalVisibleAction("statusLogVisible", true);
          },
        );
      }
    });
  }

  handleClick = () => {
    var data = [];
    // if (window.sessionStorage.getItem('top10Station') != null)
    // {
    //   data = JSON.parse((window.sessionStorage.getItem('top10Station')));
    //   if (data.length == 0)
    //   {
    //     message.error("暂无数据");
    //     return;
    //   }
    // } else {
    //   message.error("暂无数据");
    //   return;
    // }
    var option = {};
    let dataTable = [];
    if (this.state.pieData) {
      for (let i in this.state.pieData) {
        let obj = {};
        obj["状态"] = this.state.pieData[i]["ticketPriorityName"];
        obj["数量"] = this.state.pieData[i]["num"];
        obj["比例"] = this.state.pieData[i]["rate"];
        dataTable.push(obj);
      }
    }
    var header = ["状态", "数量", "比例"];
    option.fileName = "设备状态导出";
    option.datas = [
      {
        sheetData: dataTable,
        sheetName: "sheet",
        sheetFilter: header,
        sheetHeader: header,
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  };

  /**
   * 获取设备状态 device/status/qry
   */
  getAuthUser() {
    if (
      this.state.param.infoType != null &&
      (this.state.param.cityIds == null || this.state.param.cityIds == "") &&
      (this.state.param.provinceIds == null || this.state.param.provinceIds == "")
    ) {
      return;
    }
    let that = this;
    fetchHandler(queryNewDeviceStatus, {
      userId: this.state.param.userId,
      companyId: this.state.param.companyId,
      operationMode: this.state.param.operationMode,
      stubType: this.state.param.stubType,
      cityIds: this.state.param.cityIds,
      areaIds: this.state.param.areaIds,
      provinceIds: this.state.param.provinceIds,
    }).then((res) => {
      if (res.data) {
        var totalNum = 0;
        const map = new Map(Object.entries(res.data));
        var totalL = 0;
        map.forEach((val, key) => {
          totalNum += val;
          totalL++;
        });
        var rate = 0;
        var index = 1;
        var list = [];
        map.forEach((val, key) => {
          var color = "";
          if (key == "空闲") {
            color = "#CF1322";
          } else if (key == "充电中") {
            color = "#FA541C";
          } else if (key == "故障") {
            color = "#FA8C16";
          } else if (key == "车位占用") {
            color = "#40A9FF";
          } else if (key == "维护中") {
            color = "#cccccc";
          } else if (key == "离线") {
            color = "#bf613d";
          } else if (key == "在建中") {
            color = "#b3a099";
          } else if (key == "升级中") {
            color = "#e7bede";
          } else if (key == "预约等待充电中") {
            color = "#14f38c";
          } else if (key == "储能中") {
            color = "#e92dbe";
          } else if (key == "离线启动") {
            color = "#071a44";
          } else if (key == "插枪空闲") {
            color = "#5c4a4a";
          } else if (key == "在线预约中") {
            color = "#af7878";
          } else if (key == "删除") {
            color = "#2e1d1d";
          } else if (key == "锁定状态不允许充电") {
            color = "#5b89b9";
          } else if (key == "充满") {
            color = "#50a346";
          }
          var noe;
          if (index == totalL) {
            noe = (100 - rate).toFixed(2);
          } else {
            noe = val == 0 ? 0 : ((val / totalNum) * 100).toFixed(2);
            console.info("noe：" + noe + "::" + totalL + ";;" + index);
          }
          rate += parseFloat(noe);

          list.push({ ticketPriorityName: key, rate: noe, color: color, num: val });
          index++;
        });

        console.info(list);
        this.setState({
          pieData: list,
        });
      } else {
        this.setState({
          pieData: [],
        });
      }
    });
  }

  /**
   * 获取执行公司
   */
  getCompany() {
    let that = this;
    fetchHandler(geServiceCompanyListrOptions, {
      userId: sessionStorage.getItem("userId"),
      relaType: 1,
    }).then((res) => {
      if (res.data) {
        res.data.forEach(function (item) {
          item.text = item.companyName;
          item.value = item.companyId;
        });
        res.data.unshift({
          value: "1",
          text: "开迈斯新能源科技有限公司",
        });
        res.data.unshift({
          text: "全部",
          value: "",
        });
        this.setState(
          {
            companyList: res.data,
          },
          () => {
            this.setState({
              formConfig: this.initForm(),
            });
          },
        );
      }
    });
  }

  /**
   * 获取设备累计数据
   */
  getEquipmentQry() {
    if (
      this.state.param.infoType != null &&
      (this.state.param.cityIds == null || this.state.param.cityIds == "") &&
      (this.state.param.provinceIds == null || this.state.param.provinceIds == "")
    ) {
      this.setState({
        equipmentQry: {
          jStubNum: 0,
          kw: 0,
          stationNum: 0,
          stubNum: 0,
          zStubNum: 0,
        },
      });
      return;
    }

    fetchHandler(queryNewDeviceNum, {
      userId: this.state.param.userId,
      companyId: this.state.param.companyId,
      operationMode: this.state.param.operationMode,
      stubType: this.state.param.stubType,
      cityIds: this.state.param.cityIds,
      areaIds: this.state.param.areaIds,
      provinceIds: this.state.param.provinceIds,
    }).then((res) => {
      if (res.data) {
        this.setState({
          equipmentQry: {
            jStubNum: res.data.jStubNum,
            kw: res.data.kw,
            stationNum: res.data.stationNum,
            stubNum: res.data.stubNum,
            zStubNum: res.data.zStubNum,
          },
        });
      }
    });
  }

  /**
   * 获取城市数据
   */
  getCityList = () => {
    fetchHandler(getCityList, { cityType: 1, userId: sessionStorage.getItem("userId") }).then(
      (res) => {
        if (!res.data) {
          return;
        }
        const fetchPickerOptions = res.data;
        let formatOptionsStr = JSON.stringify(fetchPickerOptions);
        formatOptionsStr = formatOptionsStr.replace(new RegExp("label", "g"), "title");
        formatOptionsStr = formatOptionsStr.replace(new RegExp("value", "g"), "value");
        formatOptionsStr = formatOptionsStr.replace(new RegExp("children", "g"), "children");
        const cityAryy = JSON.parse(formatOptionsStr);
        cityAryy.map((item) => {
          item.key = item.value;
          item.children.map((item2) => {
            item2.key = item2.value;
            delete item2.children; // 删除子区域数据
            return true;
          });
          return true;
        });
        // 初始化城市数据
        this.quanguoCityArry = [
          {
            title: "全国",
            value: "000000",
            key: "000000",
            children: JSON.parse(JSON.stringify(cityAryy)),
          },
        ];

        // 只能选择城市的方式
        this.quanguoCityNotP = [
          {
            title: "全国",
            value: "000000",
            key: "000000",
            children: JSON.parse(JSON.stringify(cityAryy)),
          },
        ];
        this.quanguoCityNotP.map((item) => {
          item.disabled = true;
          item.children.map((item1) => {
            item1.disabled = true;
            item1.children.map((item2) => {
              item2.disabled = false;
              return true;
            });
            return true;
          });
          return true;
        });
        // 只能选择省份的数组
        this.quanguoCityNotCity = [
          {
            title: "全国",
            value: "000000",
            key: "000000",
            children: JSON.parse(JSON.stringify(cityAryy)),
          },
        ];
        this.quanguoCityNotCity.map((item) => {
          item.disabled = true;
          item.children.map((item1) => {
            item1.disabled = false;
            item1.children.map((item2) => {
              item2.disabled = true;
              return true;
            });
            return true;
          });
          return true;
        });
        // 只能选择全国的数组
        this.quanguoCityNotChild = [
          {
            title: "全国",
            value: "000000",
            key: "000000",
            children: JSON.parse(JSON.stringify(cityAryy)),
          },
        ];
        this.quanguoCityNotChild.map((item) => {
          item.disabled = false;
          item.children.map((item1) => {
            item1.disabled = true;
            item1.children.map((item2) => {
              item2.disabled = true;
              return true;
            });
            return true;
          });
          return true;
        });
        // 设置数据
        this.setState(
          {
            quanguoCityArry: [...this.quanguoCityArry],
          },
          () => {
            this.setState({
              formConfig: this.initForm(),
            });
          },
        );
      },
    );
  };

  sortTypeChange = (value) => {};

  changeCityData = (value) => {
    if (value.length === 0) {
      // 设置数据
      this.setState(
        {
          quanguoCityArry: [...this.quanguoCityArry],
        },
        () => {
          this.setState({
            formConfig: this.initForm(),
          });
        },
      );
    }
    if (value.length === 1) {
      let quanguoCityArryCVal = "";
      if (value[0] === "000000") {
        quanguoCityArryCVal = this.quanguoCityNotChild;
      } else if (
        value[0].charAt(5) === "0" &&
        value[0].charAt(4) === "0" &&
        value[0].charAt(3) === "0" &&
        value[0].charAt(2) === "0"
      ) {
        quanguoCityArryCVal = this.quanguoCityNotCity;
      } else {
        quanguoCityArryCVal = this.quanguoCityNotP;
      }
      // 设置数据
      this.setState(
        {
          quanguoCityArry: quanguoCityArryCVal,
        },
        () => {
          this.setState({
            formConfig: this.initForm(),
          });
        },
      );
    }
  };

  modalVisibleAction(modalVisibleKey, visible) {
    this.setState({
      [modalVisibleKey]: visible,
    });
  }

  /**
   * 新开tab页方法
   */
  openTab = (param, e) => {
    this.props.onAdd(e, param);
  };

  // 加载form方法
  initForm() {
    const formConfig = {
      childItems: [
        {
          type: "select",
          placeholder: "请选择",
          labelName: "运营类型",
          param: {
            name: "operationMode",
            type: "string",
          },
          options: this.state.ticketTypeList,
          allowClear: true,
          required: false,
        },

        {
          type: "select",
          placeholder: "请选择",
          labelName: "设备类型",
          param: {
            name: "stubType",
            type: "string",
          },
          options: this.state.levelTypeList,
          allowClear: true,
          required: false,
        },
        {
          type: "select",
          placeholder: "请选择", // '请选择大区',
          labelName: "大区", // '大区',
          param: {
            name: "areaIds",
            type: "string",
          },
          options: this.state.areaList,
          allowClear: true,
          required: false,
          onChange: async (value, form) => {
            if (value == null || value == "") {
              //恢复区域信息
              form.setFieldsValue({
                cityGroup: [],
              });
            } else {
              //遍历区域，把不属于
              form.setFieldsValue({
                cityGroup: value.split(","),
              });
            }
            this.setState({
              formConfig: this.initForm(value),
            });
          },
        },
        {
          type: "select",
          placeholder: "请选择",
          labelName: "城市类别",
          param: {
            name: "infoType",
            type: "string",
          },
          options: this.state.cityTypeList,
          allowClear: true,
          required: false,
        },
        {
          type: "treeSelect",
          placeholder: "请选择地区",
          param: {
            name: "cityGroup",
            type: "array",
          },
          onChange: this.changeCityData,
          data: this.state.quanguoCityArry,
          treeCheckable: true,
          treeCheckStrictly: false,
          showCheckedStrategy: "SHOW_PARENT",
          labelName: "地区",
          required: false,
        },

        {
          type: "buttonGp", // 表单最终执行组
          buttonArr: [
            {
              btnType: "button",
              text: "查询",
              // icon: "search",
              handler: (e, param) => {
                // 设置城市数组
                let cityIds = "";
                var infoType = param.infoType; //城市类别
                // if (param.cityGroup) {
                //   param.cityGroup.map((item) => {
                //       cityIds += `${item},`;
                //       return true;
                //   });
                // }
                // 判断选择地区类型（全国、省份、城市）
                let cityType = "0"; // 0：全国，1：省份，2：城市
                if (param.cityGroup !== undefined) {
                  if (param.cityGroup.length === 0) {
                    console.info("问问3");
                    // cityIds = "000000";
                    var ids = [];
                    cityType = "2";
                    //省份下的城市 cityIds改成所选省份下的城市
                    this.state.quanguoCityArry[0].children.forEach(function (item) {
                      item.children.forEach(function (one) {
                        if (infoType && infoType != null) {
                          if (one.cityType == infoType) {
                            ids.push(one.key);
                          }
                        } else {
                          ids.push(one.key);
                        }
                      });
                    });
                    cityIds = ids.join(",");
                  } else if (param.cityGroup[0] === "000000") {
                    console.info("问问4");
                    // cityType = "0";
                    var ids = [];
                    cityType = "2";
                    //省份下的城市 cityIds改成所选省份下的城市
                    this.state.quanguoCityArry[0].children.forEach(function (item) {
                      item.children.forEach(function (one) {
                        if (infoType && infoType != null) {
                          if (one.cityType == infoType) {
                            ids.push(one.key);
                          }
                        } else {
                          ids.push(one.key);
                        }
                      });
                    });
                    cityIds = ids.join(",");
                  } else if (
                    param.cityGroup[0].charAt(5) === "0" &&
                    param.cityGroup[0].charAt(4) === "0" &&
                    param.cityGroup[0].charAt(3) === "0" &&
                    param.cityGroup[0].charAt(2) === "0"
                  ) {
                    console.info("问问5");
                    var ids = [];
                    cityType = "2";
                    //省份下的城市 cityIds改成所选省份下的城市
                    this.state.quanguoCityArry[0].children.forEach(function (item) {
                      if (param.cityGroup.indexOf(item.key) != -1) {
                        item.children.forEach(function (one) {
                          if (infoType && infoType != null) {
                            if (one.cityType == infoType) {
                              ids.push(one.key);
                            }
                          } else {
                            ids.push(one.key);
                          }
                        });
                        item.children.forEach(function (one) {});
                      }
                    });
                    cityIds = ids.join(",");
                  } else {
                    console.info("问问6" + cityIds);
                    cityType = "2";
                    this.state.quanguoCityArry[0].children.forEach(function (item) {
                      item.children.forEach(function (one) {
                        if (param.cityGroup.indexOf(one.key) != -1) {
                          if (infoType && infoType != null) {
                            if (one.cityType == infoType) {
                              cityIds += `${one.key},`;
                            }
                          } else {
                            cityIds += `${one.key},`;
                          }
                        }
                      });
                    });
                  }
                } else {
                  console.info("问问7");
                  var ids = [];
                  cityType = "2";
                  //省份下的城市 cityIds改成所选省份下的城市
                  this.state.quanguoCityArry[0].children.forEach(function (item) {
                    item.children.forEach(function (one) {
                      if (infoType && infoType != null) {
                        if (one.cityType == infoType) {
                          ids.push(one.key);
                        }
                      } else {
                        ids.push(one.key);
                      }
                    });
                  });
                  cityIds = ids.join(",");
                }
                this.setState(
                  {
                    param: {
                      cityIds: cityType === "2" ? cityIds || "" : "",
                      provinceIds: cityType === "0" || cityType === "1" ? cityIds || "000000" : "",
                      stubType: param.stubType,
                      operationMode: param.operationMode,
                      operationProperty: "3",
                      userId: param.userId,
                      infoType: param.infoType,
                      companyId: param.companyId,
                    },
                  },
                  () => {
                    // 查询设备数据
                    this.getEquipmentQry();
                    this.getAuthUser();
                  },
                );
              },
            },
          ],
        },
      ],
      layout: "inline", // 设置布局 0： 横向布局， 1：弹窗布局 2： 全页表单布局
      formTarget: "submit", // 表单提交类型，设置grid则为更新grid
      defaultParams: {
        operationProperty: "3",
      },
      autoLoadGrid: !1, // 设置为false不触发加载grid
      context: this,
      tableKey: "oprationLogTable",
    };

    return formConfig;
  }

  // style={{ "min-width": "1440px" }}
  render() {
    const content = (
      <div className="sc-page-content display-board-page">
        <div className="page-toolbar">
          <FormCore formConfig={this.state.formConfig} />
        </div>
        <div className="page-panel">
          <div className="display-board">
            <div className="item" style={{ width: "100%" }}>
              <div className="inner" style={{ padding: "24px 2%" }}>
                <div
                  className="fixed-more"
                  onClick={() => {
                    this.getAreaNumList(1);
                  }}>
                  {" "}
                  详情
                  <RightOutlined />
                </div>
                <div className="detail-info stub-info-board">
                  <div className="icon-part color1">
                    <img alt="" src={icon1} className="info-img" />
                  </div>
                  <div className="stub-info-item">
                    <div className="name">
                      电站(个){" "}
                      <Tooltip
                        title={() => (
                          <span style={{ color: "#000" }}>电站为实时数据，不随选择日期变化</span>
                        )}
                        color="#ffffff"
                        overlayClassName="white-tooltip">
                        <QuestionCircleFilled
                          style={{
                            color: "#D9D9D9",
                            marginLeft: "4px",
                            top: "1px",
                          }}
                        />
                      </Tooltip>
                    </div>
                    <div className="num">{this.state.equipmentQry.stationNum}</div>
                  </div>
                </div>
              </div>
              <div className="inner" style={{ padding: "24px 2%" }}>
                <div
                  className="fixed-more"
                  onClick={() => {
                    this.getAreaNumList(2);
                  }}>
                  {" "}
                  详情
                  <RightOutlined />
                </div>
                <div className="detail-info stub-info-board">
                  <div className="icon-part color2">
                    <img alt="" src={icon2} className="info-img" />
                  </div>
                  <div className="stub-info-item">
                    <div className="name">
                      终端总数
                      <Tooltip
                        title={() => (
                          <span style={{ color: "#000" }}>设备为实时数据，不随选择日期变化</span>
                        )}
                        color="#ffffff"
                        overlayClassName="white-tooltip">
                        <QuestionCircleFilled
                          style={{
                            color: "#D9D9D9",
                            marginLeft: "4px",
                            top: "1px",
                          }}
                        />
                      </Tooltip>
                    </div>
                    <div className="num">{this.state.equipmentQry.stubNum}</div>
                  </div>
                </div>
              </div>
              <div className="inner" style={{ padding: "24px 2%" }}>
                <div
                  className="fixed-more"
                  onClick={() => {
                    this.getAreaNumList(4);
                  }}>
                  {" "}
                  详情
                  <RightOutlined />
                </div>
                <div className="detail-info stub-info-board">
                  <div className="icon-part color3">
                    <img alt="" src={icon3} className="info-img" />
                  </div>
                  <div className="stub-info-item">
                    <div className="name">
                      交流终端数
                      <Tooltip
                        title={() => (
                          <span style={{ color: "#000" }}>设备为实时数据，不随选择日期变化</span>
                        )}
                        color="#ffffff"
                        overlayClassName="white-tooltip">
                        <QuestionCircleFilled
                          style={{
                            color: "#D9D9D9",
                            marginLeft: "4px",
                            top: "1px",
                          }}
                        />
                      </Tooltip>
                    </div>
                    <div className="num">{this.state.equipmentQry.jStubNum}</div>
                  </div>
                </div>
              </div>

              <div className="inner" style={{ padding: "24px 2%" }}>
                <div
                  className="fixed-more"
                  onClick={() => {
                    this.getAreaNumList(3);
                  }}>
                  {" "}
                  详情
                  <RightOutlined />
                </div>
                <div className="detail-info stub-info-board">
                  <div className="icon-part color3">
                    <img alt="" src={icon5} className="info-img" />
                  </div>
                  <div className="stub-info-item">
                    <div className="name">
                      直流终端数
                      <Tooltip
                        title={() => (
                          <span style={{ color: "#000" }}>设备为实时数据，不随选择日期变化</span>
                        )}
                        color="#ffffff"
                        overlayClassName="white-tooltip">
                        <QuestionCircleFilled
                          style={{
                            color: "#D9D9D9",
                            marginLeft: "4px",
                            top: "1px",
                          }}
                        />
                      </Tooltip>
                    </div>
                    <div className="num">{this.state.equipmentQry.zStubNum}</div>
                  </div>
                </div>
              </div>

              <div className="inner" style={{ padding: "24px 2%" }}>
                <div
                  className="fixed-more"
                  onClick={() => {
                    this.getAreaNumList(5);
                  }}>
                  {" "}
                  详情
                  <RightOutlined />
                </div>
                <div className="detail-info stub-info-board">
                  <div className="icon-part color3">
                    <img alt="" src={icon4} className="info-img" />
                  </div>
                  <div className="stub-info-item">
                    <div className="name">
                      额定功率
                      <Tooltip
                        title={() => (
                          <span style={{ color: "#000" }}>
                            额定功率为实时数据，不随选择日期变化，10位只取01设备的功率
                          </span>
                        )}
                        color="#ffffff"
                        overlayClassName="white-tooltip">
                        <QuestionCircleFilled
                          style={{
                            color: "#D9D9D9",
                            marginLeft: "4px",
                            top: "1px",
                          }}
                        />
                      </Tooltip>
                    </div>
                    <div className="num">{this.state.equipmentQry.kw}</div>
                  </div>
                </div>
              </div>
            </div>

            <div className="item daochu">
              <div className="inner" style={{ height: "421px" }}>
                <div className="title-box">
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div className="title">设备状态</div>
                    <Button onClick={this.handleClick} type="primary" style={{ margin: "5px" }}>
                      导出
                    </Button>
                  </div>
                  {/* <div className="search-box">
                  <span className="select-label"></span>
                  <Select
                    style={{ width: "120px", marginRight: "8px" }}>
                      {this.state.areaList.map((v) => (
                    <Select.Option value={v.value}>{v.text}</Select.Option>
                  ))}
                  </Select>
                  <TreeSelect
                    style={{ width: "200px" }}
                    treeData={this.state.quanguoCityArry}
                    onChange={this.changeCityData}
                    placeholder={'请选择地区'}
                    allowClear
                    className="form-core-tree-select"
                    showSearch
                    treeCheckable={true}
                    treeCheckStrictly={false}
                    treeNodeFilterProp="title"
                    showCheckedStrategy={'SHOW_PARENT'}
                  />

                </div> */}
                </div>
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <PeoplePieChart chartId="glllPieMMM" pieType="1" param={this.state.pieData} />
                </div>
              </div>
            </div>

            <div className="item daochu">
              <div className="inner" style={{ minHeight: "521px" }}>
                <div>
                  <DeviceInfoSub
                    getStubIntactRate={this.getStubIntactRate}
                    param={this.state.param}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <Modal
          title={this.state.modalTitle}
          visible={this.state.statusLogVisible}
          footer={null}
          destroyOnClose
          width="800px"
          onCancel={() => {
            this.modalVisibleAction("statusLogVisible", false);
          }}>
          <StationModal
            modalParam={this.state.param}
            stubIdData={this.state.areaDTOList}
            modalType={this.state.modalType}
            firstId={this.state.fAreaId}
            modalStationTitle={this.state.modalStationTitle}
            modalStationNum={this.state.modalStationNum}
          />
        </Modal>
      </div>
    );
    return content;
  }
}

export default injectIntl(DeviceWatchPlat);



// WEBPACK FOOTER //
// ./src/AntD/pages/displayBoard/deviceWatchPlat.js